// extracted by mini-css-extract-plugin
export var avatar = "_mh-3";
export var avatarContainer = "_mh-2";
export var avatarSpacer = "_mh-5";
export var avatarSpacerContainer = "_mh-4";
export var avatarStackContainer = "_mh-1";
export var bubble = "_mh-0";
export var remainderBubble = "_mh-6";